import axios from 'axios';

// Registro global
//axios.defaults.baseURL = 'http://177.19.159.202:8080/ikponto/servico';
axios.defaults.baseURL = 'https://backend.ikponto.com.br/servico';
export default axios;